<template>
  <div class="downloadMaterials">
      <DownloadMaterialsTop ref="DownloadMaterialsTop" :SwiperList="SwiperList"></DownloadMaterialsTop>
  </div>
</template>

<script>
import DownloadMaterialsTop from './DownloadMaterialsComponents/DownloadMaterialsTop.vue'
export default {
  components: {
      DownloadMaterialsTop,
  },
 props: {
    // 轮播数据
    SwiperList: {
      type: Array
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.downloadMaterials{
    width: 100%;
    height: 340px;
    background-color:  #002B66;
}
</style>